export const ApplicantStatus = {
  NONE: "NONE",
  HOLD: "HOLD",
  PASSED: "PASSED",
  FAILED: "FAILED",
};

export const ApplicantFilterStatusPersonal = {
  APPLIED: "APPLIED",
  REQUESTED: "REQUESTED",
  ACCEPTED: "ACCEPTED",
  CONFIRMED: "CONFIRMED",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
};

export const ApplicantFilterPeriodPersonal = {
  ONE_MONTH: "ONE_MONTH",
  THREE_MONTHS: "THREE_MONTHS",
  ONE_YEAR: "ONE_YEAR",
};

export const ApplicantFilterProgressCorporate = {
  RECEIPTION_PROGRESS: "RECEIPTION_PROGRESS",
  INTERVIEW_PROGRESS: "INTERVIEW_PROGRESS",
  WAiTING: "WAiTING",
};

export const ApplicantFilterStatusCorporate = {
  APPLY: "APPLY",
  VIEW_RESUME: "VIEW_RESUME",
  REQUESTED: "REQUESTED",
  ACCEPTED: "ACCEPTED",
  CONFIRMED: "CONFIRMED",
  CANCELED: "CANCELED",
  COMPLETED: "COMPLETED",
  REQUEST_CHANGED: "REQUEST_CHANGED",
};

export const InterviewType = {
  JOB: "JOB",
  TALENT: "TALENT",
};

export const InterviewStatus = {
  REQUESTED: "REQUESTED",
  ACCEPTED: "ACCEPTED",
  CONFIRMED: "CONFIRMED",
  CANCELED: "CANCELED",
  COMPLETED: "COMPLETED",
  REQUEST_CHANGED: "REQUEST_CHANGED",
};

export const InterviewResult = {
  HOLD: "HOLD",
  PASSED: "PASSED",
  FAILED: "FAILED",
};

export const ApplicantFilterPeriodCorporate = {
  FIRST_HALF_YEAR: "FIRST_HALF_YEAR",
  SECOND_HALF_YEAR: "SECOND_HALF_YEAR",
};

export const ApplicantType = {
  JOB: "JOB",
  TALENT: "TALENT",
};
